window.HS_SWATCH_DATA = window.HS_SWATCH_DATA || {};
window.HS_SWATCH_DATA["roller-sunscreen"] = {
  "product_key": "roller-sunscreen",
  "minimum_order_quantity": 5,
  "tier_guide": [
    {
      "tier": "Tier 1",
      "label": "Essential"
    },
    {
      "tier": "Tier 2",
      "label": "Standard"
    },
    {
      "tier": "Tier 3",
      "label": "Premium"
    },
    {
      "tier": "Tier 4",
      "label": "Luxury"
    }
  ],
  "swatches": [
    {
      "id": "roller-sunscreen-MS12-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS12",
      "fabric_code": "MS12-001",
      "web_name": "Soft White Weave",
      "name_key": "soft-white-weave",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEyLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS12-001.jpg",
      "search_text": "MS12-001 Soft White Weave Essential",
      "sort_order": 252,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS12-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS12",
      "fabric_code": "MS12-002",
      "web_name": "Warm Sand Thread",
      "name_key": "warm-sand-thread",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEyLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS12-002.jpg",
      "search_text": "MS12-002 Warm Sand Thread Essential",
      "sort_order": 253,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS12-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS12",
      "fabric_code": "MS12-003",
      "web_name": "Cool Silver Mesh",
      "name_key": "cool-silver-mesh",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEyLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS12-003.jpg",
      "search_text": "MS12-003 Cool Silver Mesh Essential",
      "sort_order": 254,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS12-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS12",
      "fabric_code": "MS12-004",
      "web_name": "Charcoal Gray Loom",
      "name_key": "charcoal-gray-loom",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEyLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS12-004.jpg",
      "search_text": "MS12-004 Charcoal Gray Loom Essential",
      "sort_order": 255,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS7-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS7",
      "fabric_code": "MS7-001",
      "web_name": "Bright White Screen",
      "name_key": "bright-white-screen",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzctMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147427225819-MS7-001.jpg",
      "search_text": "MS7-001 Bright White Screen Essential",
      "sort_order": 256,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS11-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS11",
      "fabric_code": "MS11-001",
      "web_name": "Bright White Weave",
      "name_key": "bright-white-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzExLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS11-001.jpg",
      "search_text": "MS11-001 Bright White Weave Essential",
      "sort_order": 257,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS11-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS11",
      "fabric_code": "MS11-002",
      "web_name": "Soft Ivory Knit",
      "name_key": "soft-ivory-knit",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzExLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS11-002.jpg",
      "search_text": "MS11-002 Soft Ivory Knit Essential",
      "sort_order": 258,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS11-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS11",
      "fabric_code": "MS11-003",
      "web_name": "Medium Gray Mesh",
      "name_key": "medium-gray-mesh",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzExLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS11-003.jpg",
      "search_text": "MS11-003 Medium Gray Mesh Essential",
      "sort_order": 259,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS11-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS11",
      "fabric_code": "MS11-004",
      "web_name": "Pale Gray Weave",
      "name_key": "pale-gray-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzExLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS11-004.jpg",
      "search_text": "MS11-004 Pale Gray Weave Essential",
      "sort_order": 260,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS11-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS11",
      "fabric_code": "MS11-005",
      "web_name": "Charcoal Gray Fiber",
      "name_key": "charcoal-gray-fiber",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzExLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS11-005.jpg",
      "search_text": "MS11-005 Charcoal Gray Fiber Essential",
      "sort_order": 261,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS11-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS11",
      "fabric_code": "MS11-006",
      "web_name": "Dark Charcoal Canvas",
      "name_key": "dark-charcoal-canvas",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzExLTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS11-006.jpg",
      "search_text": "MS11-006 Dark Charcoal Canvas Essential",
      "sort_order": 262,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-001",
      "web_name": "Bright White Strand",
      "name_key": "bright-white-strand",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-001.jpg",
      "search_text": "MS15-001 Bright White Strand Essential",
      "sort_order": 263,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-002",
      "web_name": "Soft Ivory Textile",
      "name_key": "soft-ivory-textile",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-002.jpg",
      "search_text": "MS15-002 Soft Ivory Textile Essential",
      "sort_order": 264,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-003",
      "web_name": "Light Gray Weave",
      "name_key": "light-gray-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-003.jpg",
      "search_text": "MS15-003 Light Gray Weave Essential",
      "sort_order": 265,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-004",
      "web_name": "Charcoal Gray Thread",
      "name_key": "charcoal-gray-thread",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-004.jpg",
      "search_text": "MS15-004 Charcoal Gray Thread Essential",
      "sort_order": 266,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-005",
      "web_name": "Dark Charcoal Mesh",
      "name_key": "dark-charcoal-mesh",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-005.jpg",
      "search_text": "MS15-005 Dark Charcoal Mesh Essential",
      "sort_order": 267,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-006",
      "web_name": "Cool Gray Loom",
      "name_key": "cool-gray-loom",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-006.jpg",
      "search_text": "MS15-006 Cool Gray Loom Essential",
      "sort_order": 268,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-007",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-007",
      "web_name": "Warm Gray Knit",
      "name_key": "warm-gray-knit",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-007.jpg",
      "search_text": "MS15-007 Warm Gray Knit Essential",
      "sort_order": 269,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS15-008",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS15",
      "fabric_code": "MS15-008",
      "web_name": "Charcoal Gray Screen",
      "name_key": "charcoal-gray-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE1LTAwOC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS15-008.jpg",
      "search_text": "MS15-008 Charcoal Gray Screen Essential",
      "sort_order": 270,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS6-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS6",
      "fabric_code": "MS6-001",
      "web_name": "Soft White Screen",
      "name_key": "soft-white-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzYtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147427225819-MS6-001.jpg",
      "search_text": "MS6-001 Soft White Screen Essential",
      "sort_order": 271,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS10-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS10",
      "fabric_code": "MS10-001",
      "web_name": "Bright White Knit",
      "name_key": "bright-white-knit",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEwLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS10-001.jpg",
      "search_text": "MS10-001 Bright White Knit Essential",
      "sort_order": 272,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS10-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS10",
      "fabric_code": "MS10-002",
      "web_name": "Soft Ivory Mesh",
      "name_key": "soft-ivory-mesh",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEwLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS10-002.jpg",
      "search_text": "MS10-002 Soft Ivory Mesh Essential",
      "sort_order": 273,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS10-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS10",
      "fabric_code": "MS10-003",
      "web_name": "Pale Gray Thread",
      "name_key": "pale-gray-thread",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEwLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS10-003.jpg",
      "search_text": "MS10-003 Pale Gray Thread Essential",
      "sort_order": 274,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS10-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS10",
      "fabric_code": "MS10-004",
      "web_name": "Medium Gray Loom",
      "name_key": "medium-gray-loom",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEwLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS10-004.jpg",
      "search_text": "MS10-004 Medium Gray Loom Essential",
      "sort_order": 275,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS10-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS10",
      "fabric_code": "MS10-005",
      "web_name": "Charcoal Gray Mesh",
      "name_key": "charcoal-gray-mesh",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEwLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS10-005.jpg",
      "search_text": "MS10-005 Charcoal Gray Mesh Essential",
      "sort_order": 276,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS10-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS10",
      "fabric_code": "MS10-006",
      "web_name": "Dark Charcoal Screen",
      "name_key": "dark-charcoal-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzEwLTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS10-006.jpg",
      "search_text": "MS10-006 Dark Charcoal Screen Essential",
      "sort_order": 277,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS22-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS22",
      "fabric_code": "MS22-001",
      "web_name": "Soft Ivory Screen",
      "name_key": "soft-ivory-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzIyLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS22-001.jpg",
      "search_text": "MS22-001 Soft Ivory Screen Essential",
      "sort_order": 278,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS22-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS22",
      "fabric_code": "MS22-002",
      "web_name": "Soft Gray Weave",
      "name_key": "soft-gray-weave",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzIyLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS22-002.jpg",
      "search_text": "MS22-002 Soft Gray Weave Essential",
      "sort_order": 279,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS22-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS22",
      "fabric_code": "MS22-003",
      "web_name": "Muted Gray Thread",
      "name_key": "muted-gray-thread",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzIyLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS22-003.jpg",
      "search_text": "MS22-003 Muted Gray Thread Essential",
      "sort_order": 280,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS22-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS22",
      "fabric_code": "MS22-004",
      "web_name": "Dark Gray Loom",
      "name_key": "dark-gray-loom",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzIyLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS22-004.jpg",
      "search_text": "MS22-004 Dark Gray Loom Essential",
      "sort_order": 281,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS17-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS17",
      "fabric_code": "MS17-001",
      "web_name": "Bright White Thread",
      "name_key": "bright-white-thread",
      "openness": "2%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE3LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS17-001.jpg",
      "search_text": "MS17-001 Bright White Thread Essential",
      "sort_order": 282,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS17-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS17",
      "fabric_code": "MS17-002",
      "web_name": "Soft Gray Mesh",
      "name_key": "soft-gray-mesh",
      "openness": "2%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE3LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS17-002.jpg",
      "search_text": "MS17-002 Soft Gray Mesh Essential",
      "sort_order": 283,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS17-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS17",
      "fabric_code": "MS17-003",
      "web_name": "Dark Gray Screen",
      "name_key": "dark-gray-screen",
      "openness": "2%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE3LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS17-003.jpg",
      "search_text": "MS17-003 Dark Gray Screen Essential",
      "sort_order": 284,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS19-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS19",
      "fabric_code": "MS19-001",
      "web_name": "Pure White Screen",
      "name_key": "pure-white-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE5LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS19-001.jpg",
      "search_text": "MS19-001 Pure White Screen Essential",
      "sort_order": 285,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS19-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS19",
      "fabric_code": "MS19-002",
      "web_name": "Light Gray Mesh",
      "name_key": "light-gray-mesh",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE5LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS19-002.jpg",
      "search_text": "MS19-002 Light Gray Mesh Essential",
      "sort_order": 286,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS19-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS19",
      "fabric_code": "MS19-003",
      "web_name": "Medium Gray Weave",
      "name_key": "medium-gray-weave",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE5LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS19-003.jpg",
      "search_text": "MS19-003 Medium Gray Weave Essential",
      "sort_order": 287,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS19-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS19",
      "fabric_code": "MS19-004",
      "web_name": "Dark Gray Thread",
      "name_key": "dark-gray-thread",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE5LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS19-004.jpg",
      "search_text": "MS19-004 Dark Gray Thread Essential",
      "sort_order": 288,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS19-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 1",
      "collection_label": "Essential",
      "source_product_label": "Sunscreen Shades Openness 1% 2% 3% 5% 10% - Essential",
      "fabric_series": "MS19",
      "fabric_code": "MS19-005",
      "web_name": "Charcoal Gray Weave",
      "name_key": "charcoal-gray-weave",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzQyNzIyNTgxOS1NUzE5LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147427225819-MS19-005.jpg",
      "search_text": "MS19-005 Charcoal Gray Weave Essential",
      "sort_order": 289,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS18-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS18",
      "fabric_code": "MS18-001",
      "web_name": "Clean White Weave",
      "name_key": "clean-white-weave",
      "openness": "8%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE4LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS18-001.jpg",
      "search_text": "MS18-001 Clean White Weave Standard",
      "sort_order": 290,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS18-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS18",
      "fabric_code": "MS18-002",
      "web_name": "Warm White Screen",
      "name_key": "warm-white-screen",
      "openness": "8%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE4LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS18-002.jpg",
      "search_text": "MS18-002 Warm White Screen Standard",
      "sort_order": 291,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS18-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS18",
      "fabric_code": "MS18-003",
      "web_name": "Pale Gray Mesh",
      "name_key": "pale-gray-mesh",
      "openness": "8%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE4LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS18-003.jpg",
      "search_text": "MS18-003 Pale Gray Mesh Standard",
      "sort_order": 292,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS18-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS18",
      "fabric_code": "MS18-004",
      "web_name": "Gentle Gray Weave",
      "name_key": "gentle-gray-weave",
      "openness": "8%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE4LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS18-004.jpg",
      "search_text": "MS18-004 Gentle Gray Weave Standard",
      "sort_order": 293,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS23-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS23",
      "fabric_code": "MS23-001",
      "web_name": "Off White Screen",
      "name_key": "off-white-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzIzLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS23-001.jpg",
      "search_text": "MS23-001 Off White Screen Standard",
      "sort_order": 294,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS23-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS23",
      "fabric_code": "MS23-002",
      "web_name": "Soft White Thread",
      "name_key": "soft-white-thread",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzIzLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS23-002.jpg",
      "search_text": "MS23-002 Soft White Thread Standard",
      "sort_order": 295,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS23-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS23",
      "fabric_code": "MS23-003",
      "web_name": "Medium Gray Screen",
      "name_key": "medium-gray-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzIzLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS23-003.jpg",
      "search_text": "MS23-003 Medium Gray Screen Standard",
      "sort_order": 296,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS25-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS25",
      "fabric_code": "MS25-001",
      "web_name": "Linen White Weave",
      "name_key": "linen-white-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI1LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS25-001.jpg",
      "search_text": "MS25-001 Linen White Weave Standard",
      "sort_order": 297,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS25-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS25",
      "fabric_code": "MS25-002",
      "web_name": "Silver Gray Mesh",
      "name_key": "silver-gray-mesh",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI1LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS25-002.jpg",
      "search_text": "MS25-002 Silver Gray Mesh Standard",
      "sort_order": 298,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS25-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS25",
      "fabric_code": "MS25-003",
      "web_name": "Steel Gray Weave",
      "name_key": "steel-gray-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI1LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS25-003.jpg",
      "search_text": "MS25-003 Steel Gray Weave Standard",
      "sort_order": 299,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS25-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS25",
      "fabric_code": "MS25-004",
      "web_name": "Graphite Gray Loom",
      "name_key": "graphite-gray-loom",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI1LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS25-004.jpg",
      "search_text": "MS25-004 Graphite Gray Loom Standard",
      "sort_order": 300,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS25-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS25",
      "fabric_code": "MS25-005",
      "web_name": "Warm Taupe Mesh",
      "name_key": "warm-taupe-mesh",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI1LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS25-005.jpg",
      "search_text": "MS25-005 Warm Taupe Mesh Standard",
      "sort_order": 301,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS25-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS25",
      "fabric_code": "MS25-006",
      "web_name": "Mocha Gray Screen",
      "name_key": "mocha-gray-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI1LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS25-006.jpg",
      "search_text": "MS25-006 Mocha Gray Screen Standard",
      "sort_order": 302,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-001",
      "web_name": "Snow White Screen",
      "name_key": "snow-white-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-001.jpg",
      "search_text": "MS26-001 Snow White Screen Standard",
      "sort_order": 303,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-002",
      "web_name": "Warm Ivory Loom",
      "name_key": "warm-ivory-loom",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-002.jpg",
      "search_text": "MS26-002 Warm Ivory Loom Standard",
      "sort_order": 304,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-003",
      "web_name": "Cool Gray Weave",
      "name_key": "cool-gray-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-003.jpg",
      "search_text": "MS26-003 Cool Gray Weave Standard",
      "sort_order": 305,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-004",
      "web_name": "Stone Gray Mesh",
      "name_key": "stone-gray-mesh",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-004.jpg",
      "search_text": "MS26-004 Stone Gray Mesh Standard",
      "sort_order": 306,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-005",
      "web_name": "Graphite Gray Screen",
      "name_key": "graphite-gray-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-005.jpg",
      "search_text": "MS26-005 Graphite Gray Screen Standard",
      "sort_order": 307,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-006",
      "web_name": "Smoked Gray Weave",
      "name_key": "smoked-gray-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-006.jpg",
      "search_text": "MS26-006 Smoked Gray Weave Standard",
      "sort_order": 308,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS26-007",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS26",
      "fabric_code": "MS26-007",
      "web_name": "Onyx Black Screen",
      "name_key": "onyx-black-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzI2LTAwNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS26-007.jpg",
      "search_text": "MS26-007 Onyx Black Screen Standard",
      "sort_order": 309,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS14-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS14",
      "fabric_code": "MS14-001",
      "web_name": "Pearl White Weave",
      "name_key": "pearl-white-weave",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE0LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS14-001.jpg",
      "search_text": "MS14-001 Pearl White Weave Standard",
      "sort_order": 310,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS14-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS14",
      "fabric_code": "MS14-002",
      "web_name": "Warm Ivory Screen",
      "name_key": "warm-ivory-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE0LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS14-002.jpg",
      "search_text": "MS14-002 Warm Ivory Screen Standard",
      "sort_order": 311,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS14-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS14",
      "fabric_code": "MS14-003",
      "web_name": "Cool Ash Mesh",
      "name_key": "cool-ash-mesh",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE0LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS14-003.jpg",
      "search_text": "MS14-003 Cool Ash Mesh Standard",
      "sort_order": 312,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS14-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS14",
      "fabric_code": "MS14-004",
      "web_name": "Slate Gray Weave",
      "name_key": "slate-gray-weave",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzE0LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147381481691-MS14-004.jpg",
      "search_text": "MS14-004 Slate Gray Weave Standard",
      "sort_order": 313,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS9-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS9",
      "fabric_code": "MS9-001",
      "web_name": "Cloud White Screen",
      "name_key": "cloud-white-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzktMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147381481691-MS9-001.jpg",
      "search_text": "MS9-001 Cloud White Screen Standard",
      "sort_order": 314,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS9-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS9",
      "fabric_code": "MS9-002",
      "web_name": "Cream White Screen",
      "name_key": "cream-white-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzktMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147381481691-MS9-002.jpg",
      "search_text": "MS9-002 Cream White Screen Standard",
      "sort_order": 315,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS9-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS9",
      "fabric_code": "MS9-003",
      "web_name": "Silver Gray Screen",
      "name_key": "silver-gray-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzktMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147381481691-MS9-003.jpg",
      "search_text": "MS9-003 Silver Gray Screen Standard",
      "sort_order": 316,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS9-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS9",
      "fabric_code": "MS9-004",
      "web_name": "Stone Gray Screen",
      "name_key": "stone-gray-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzktMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147381481691-MS9-004.jpg",
      "search_text": "MS9-004 Stone Gray Screen Standard",
      "sort_order": 317,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS9-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 2",
      "collection_label": "Standard",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 8% - Standard",
      "fabric_series": "MS9",
      "fabric_code": "MS9-005",
      "web_name": "Deep Charcoal Screen",
      "name_key": "deep-charcoal-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzM4MTQ4MTY5MS1NUzktMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147381481691-MS9-005.jpg",
      "search_text": "MS9-005 Deep Charcoal Screen Standard",
      "sort_order": 318,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS24-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS24",
      "fabric_code": "MS24-001",
      "web_name": "Alpine White Weave",
      "name_key": "alpine-white-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzI0LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS24-001.jpg",
      "search_text": "MS24-001 Alpine White Weave Premium",
      "sort_order": 319,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS24-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS24",
      "fabric_code": "MS24-002",
      "web_name": "Golden Ivory Weave",
      "name_key": "golden-ivory-weave",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzI0LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS24-002.jpg",
      "search_text": "MS24-002 Golden Ivory Weave Premium",
      "sort_order": 320,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS24-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS24",
      "fabric_code": "MS24-003",
      "web_name": "Soft White Loom",
      "name_key": "soft-white-loom",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzI0LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS24-003.jpg",
      "search_text": "MS24-003 Soft White Loom Premium",
      "sort_order": 321,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS2-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS2",
      "fabric_code": "MS2-001",
      "web_name": "Arctic White Screen",
      "name_key": "arctic-white-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzItMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MS2-001.jpg",
      "search_text": "MS2-001 Arctic White Screen Premium",
      "sort_order": 322,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS2-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS2",
      "fabric_code": "MS2-002",
      "web_name": "Ivory Glow Screen",
      "name_key": "ivory-glow-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzItMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MS2-002.jpg",
      "search_text": "MS2-002 Ivory Glow Screen Premium",
      "sort_order": 323,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS2-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS2",
      "fabric_code": "MS2-003",
      "web_name": "Cool Gray Screen",
      "name_key": "cool-gray-screen",
      "openness": "5%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzItMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MS2-003.jpg",
      "search_text": "MS2-003 Cool Gray Screen Premium",
      "sort_order": 324,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS5-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS5",
      "fabric_code": "MS5-001",
      "web_name": "Cool White Loom",
      "name_key": "cool-white-loom",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzUtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MS5-001.jpg",
      "search_text": "MS5-001 Cool White Loom Premium",
      "sort_order": 325,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS21-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS21",
      "fabric_code": "MS21-001",
      "web_name": "Soft Silver Weave",
      "name_key": "soft-silver-weave",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzIxLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS21-001.jpg",
      "search_text": "MS21-001 Soft Silver Weave Premium",
      "sort_order": 326,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS21-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS21",
      "fabric_code": "MS21-002",
      "web_name": "Warm Gray Weave",
      "name_key": "warm-gray-weave",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzIxLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS21-002.jpg",
      "search_text": "MS21-002 Warm Gray Weave Premium",
      "sort_order": 327,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS21-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS21",
      "fabric_code": "MS21-003",
      "web_name": "Graphite Gray Mesh",
      "name_key": "graphite-gray-mesh",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzIxLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS21-003.jpg",
      "search_text": "MS21-003 Graphite Gray Mesh Premium",
      "sort_order": 328,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS21-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS21",
      "fabric_code": "MS21-004",
      "web_name": "Charcoal Gray Lattice",
      "name_key": "charcoal-gray-lattice",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzIxLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS21-004.jpg",
      "search_text": "MS21-004 Charcoal Gray Lattice Premium",
      "sort_order": 329,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF1-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF1",
      "fabric_code": "MF1-001",
      "web_name": "Porcelain Whisper Sheer",
      "name_key": "porcelain-whisper-sheer",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjEtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF1-001.jpg",
      "search_text": "MF1-001 Porcelain Whisper Sheer Premium",
      "sort_order": 330,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF1-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF1",
      "fabric_code": "MF1-002",
      "web_name": "Champagne Filigree",
      "name_key": "champagne-filigree",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjEtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF1-002.jpg",
      "search_text": "MF1-002 Champagne Filigree Premium",
      "sort_order": 331,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF1-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF1",
      "fabric_code": "MF1-003",
      "web_name": "Pewter Damask",
      "name_key": "pewter-damask",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjEtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF1-003.jpg",
      "search_text": "MF1-003 Pewter Damask Premium",
      "sort_order": 332,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF2-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF2",
      "fabric_code": "MF2-001",
      "web_name": "Ivory Canopy",
      "name_key": "ivory-canopy",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjItMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF2-001.jpg",
      "search_text": "MF2-001 Ivory Canopy Premium",
      "sort_order": 333,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF2-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF2",
      "fabric_code": "MF2-002",
      "web_name": "Sand Dune Rack",
      "name_key": "sand-dune-rack",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjItMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF2-002.jpg",
      "search_text": "MF2-002 Sand Dune Rack Premium",
      "sort_order": 334,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF2-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF2",
      "fabric_code": "MF2-003",
      "web_name": "Silver Birch",
      "name_key": "silver-birch",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjItMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF2-003.jpg",
      "search_text": "MF2-003 Silver Birch Premium",
      "sort_order": 335,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF2-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF2",
      "fabric_code": "MF2-004",
      "web_name": "Midnight Vine",
      "name_key": "midnight-vine",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjItMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF2-004.jpg",
      "search_text": "MF2-004 Midnight Vine Premium",
      "sort_order": 336,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF2-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF2",
      "fabric_code": "MF2-005",
      "web_name": "Charcoal Grove",
      "name_key": "charcoal-grove",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjItMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF2-005.jpg",
      "search_text": "MF2-005 Charcoal Grove Premium",
      "sort_order": 337,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF2-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF2",
      "fabric_code": "MF2-006",
      "web_name": "Obsidian Leaf",
      "name_key": "obsidian-leaf",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjItMDA2LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF2-006.jpg",
      "search_text": "MF2-006 Obsidian Leaf Premium",
      "sort_order": 338,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF3-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF3",
      "fabric_code": "MF3-001",
      "web_name": "Pearl Lattice",
      "name_key": "pearl-lattice",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjMtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF3-001.jpg",
      "search_text": "MF3-001 Pearl Lattice Premium",
      "sort_order": 339,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF3-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF3",
      "fabric_code": "MF3-002",
      "web_name": "Champagne Cell",
      "name_key": "champagne-cell",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjMtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF3-002.jpg",
      "search_text": "MF3-002 Champagne Cell Premium",
      "sort_order": 340,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF3-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF3",
      "fabric_code": "MF3-003",
      "web_name": "Stone Hexa",
      "name_key": "stone-hexa",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjMtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF3-003.jpg",
      "search_text": "MF3-003 Stone Hexa Premium",
      "sort_order": 341,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MF3-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MF3",
      "fabric_code": "MF3-004",
      "web_name": "Onyx Grid",
      "name_key": "onyx-grid",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NRjMtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9147310276827-MF3-004.jpg",
      "search_text": "MF3-004 Onyx Grid Premium",
      "sort_order": 342,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS13-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS13",
      "fabric_code": "MS13-001",
      "web_name": "Chalk White Screen",
      "name_key": "chalk-white-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzEzLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS13-001.jpg",
      "search_text": "MS13-001 Chalk White Screen Premium",
      "sort_order": 343,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS13-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS13",
      "fabric_code": "MS13-002",
      "web_name": "Warm Ivory Grid",
      "name_key": "warm-ivory-grid",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzEzLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS13-002.jpg",
      "search_text": "MS13-002 Warm Ivory Grid Premium",
      "sort_order": 344,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS13-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS13",
      "fabric_code": "MS13-003",
      "web_name": "Ash Gray Screen",
      "name_key": "ash-gray-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzEzLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS13-003.jpg",
      "search_text": "MS13-003 Ash Gray Screen Premium",
      "sort_order": 345,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS13-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 3",
      "collection_label": "Premium",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% - Premium",
      "fabric_series": "MS13",
      "fabric_code": "MS13-004",
      "web_name": "Deep Charcoal Grid",
      "name_key": "deep-charcoal-grid",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0NzMxMDI3NjgyNy1NUzEzLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9147310276827-MS13-004.jpg",
      "search_text": "MS13-004 Deep Charcoal Grid Premium",
      "sort_order": 346,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS20-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS20",
      "fabric_code": "MS20-001",
      "web_name": "Glacier White Weave",
      "name_key": "glacier-white-weave",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzIwLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS20-001.jpg",
      "search_text": "MS20-001 Glacier White Weave Luxury",
      "sort_order": 347,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS20-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS20",
      "fabric_code": "MS20-002",
      "web_name": "Vanilla Ivory Screen",
      "name_key": "vanilla-ivory-screen",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzIwLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS20-002.jpg",
      "search_text": "MS20-002 Vanilla Ivory Screen Luxury",
      "sort_order": 348,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS20-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS20",
      "fabric_code": "MS20-003",
      "web_name": "Dove Gray Mesh",
      "name_key": "dove-gray-mesh",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzIwLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS20-003.jpg",
      "search_text": "MS20-003 Dove Gray Mesh Luxury",
      "sort_order": 349,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS20-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS20",
      "fabric_code": "MS20-004",
      "web_name": "Iron Gray Loom",
      "name_key": "iron-gray-loom",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzIwLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS20-004.jpg",
      "search_text": "MS20-004 Iron Gray Loom Luxury",
      "sort_order": 350,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS20-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS20",
      "fabric_code": "MS20-005",
      "web_name": "Smoke Gray Screen",
      "name_key": "smoke-gray-screen",
      "openness": "10%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzIwLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS20-005.jpg",
      "search_text": "MS20-005 Smoke Gray Screen Luxury",
      "sort_order": 351,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS1-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS1",
      "fabric_code": "MS1-001",
      "web_name": "Ice White Screen",
      "name_key": "ice-white-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzEtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS1-001.jpg",
      "search_text": "MS1-001 Ice White Screen Luxury",
      "sort_order": 352,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS1-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS1",
      "fabric_code": "MS1-002",
      "web_name": "Biscuit Ivory Screen",
      "name_key": "biscuit-ivory-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzEtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS1-002.jpg",
      "search_text": "MS1-002 Biscuit Ivory Screen Luxury",
      "sort_order": 353,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS1-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS1",
      "fabric_code": "MS1-003",
      "web_name": "Storm Gray Screen",
      "name_key": "storm-gray-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzEtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS1-003.jpg",
      "search_text": "MS1-003 Storm Gray Screen Luxury",
      "sort_order": 354,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS1-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS1",
      "fabric_code": "MS1-004",
      "web_name": "Pewter Gray Screen",
      "name_key": "pewter-gray-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzEtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS1-004.jpg",
      "search_text": "MS1-004 Pewter Gray Screen Luxury",
      "sort_order": 355,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS16-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS16",
      "fabric_code": "MS16-001",
      "web_name": "Crystal White Screen",
      "name_key": "crystal-white-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzE2LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS16-001.jpg",
      "search_text": "MS16-001 Crystal White Screen Luxury",
      "sort_order": 356,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS16-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS16",
      "fabric_code": "MS16-002",
      "web_name": "Mist White Screen",
      "name_key": "mist-white-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzE2LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS16-002.jpg",
      "search_text": "MS16-002 Mist White Screen Luxury",
      "sort_order": 357,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS16-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS16",
      "fabric_code": "MS16-003",
      "web_name": "Honey Ivory Screen",
      "name_key": "honey-ivory-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzE2LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS16-003.jpg",
      "search_text": "MS16-003 Honey Ivory Screen Luxury",
      "sort_order": 358,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS16-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS16",
      "fabric_code": "MS16-004",
      "web_name": "Cloud Gray Screen",
      "name_key": "cloud-gray-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzE2LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS16-004.jpg",
      "search_text": "MS16-004 Cloud Gray Screen Luxury",
      "sort_order": 359,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS16-005",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS16",
      "fabric_code": "MS16-005",
      "web_name": "Granite Gray Screen",
      "name_key": "granite-gray-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzE2LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS16-005.jpg",
      "search_text": "MS16-005 Granite Gray Screen Luxury",
      "sort_order": 360,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS16-006",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS16",
      "fabric_code": "MS16-006",
      "web_name": "Cocoa Gray Screen",
      "name_key": "cocoa-gray-screen",
      "openness": "3%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzE2LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842020571-MS16-006.jpg",
      "search_text": "MS16-006 Cocoa Gray Screen Luxury",
      "sort_order": 361,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS4-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS4",
      "fabric_code": "MS4-001",
      "web_name": "Arctic Gray Screen",
      "name_key": "arctic-gray-screen",
      "openness": "1%",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzQtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS4-001.jpg",
      "search_text": "MS4-001 Arctic Gray Screen Luxury",
      "sort_order": 362,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS3-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS3",
      "fabric_code": "MS3-001",
      "web_name": "Frost White Screen",
      "name_key": "frost-white-screen",
      "openness": "",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzMtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS3-001.jpg",
      "search_text": "MS3-001 Frost White Screen Luxury",
      "sort_order": 363,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS8-001",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS8",
      "fabric_code": "MS8-001",
      "web_name": "Paper White Screen",
      "name_key": "paper-white-screen",
      "openness": "",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzgtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS8-001.jpg",
      "search_text": "MS8-001 Paper White Screen Luxury",
      "sort_order": 364,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS8-002",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS8",
      "fabric_code": "MS8-002",
      "web_name": "Buttermilk Screen",
      "name_key": "buttermilk-screen",
      "openness": "",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzgtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS8-002.jpg",
      "search_text": "MS8-002 Buttermilk Screen Luxury",
      "sort_order": 365,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS8-003",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS8",
      "fabric_code": "MS8-003",
      "web_name": "Icy Gray Screen",
      "name_key": "icy-gray-screen",
      "openness": "",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzgtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS8-003.jpg",
      "search_text": "MS8-003 Icy Gray Screen Luxury",
      "sort_order": 366,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-sunscreen-MS8-004",
      "roller_type": "roller",
      "shade_type": "sunscreen",
      "swatch_product_key": "roller-sunscreen",
      "tier": "Tier 4",
      "collection_label": "Luxury",
      "source_product_label": "Sunscreen Shades Openness 1% 3% 5% 10% - Luxury",
      "fabric_series": "MS8",
      "fabric_code": "MS8-004",
      "web_name": "Graphite Charcoal Screen",
      "name_key": "graphite-charcoal-screen",
      "openness": "",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjAyMDU3MS1NUzgtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842020571-MS8-004.jpg",
      "search_text": "MS8-004 Graphite Charcoal Screen Luxury",
      "sort_order": 367,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    }
  ]
};
